import { defineStore } from "pinia"
import { ref, computed } from "vue"

export const useCounterStore = defineStore("counter", () => {
  // State
  const state = reactive({
    count: 5,
    ip: null,
    userInfo: "bbb",
  })

  // Actions
  const setData = (key, value, append = false) => {
    if (Array.isArray(state[key]) && append) {
      state[key] = [...state[key], ...value] // 如果是数组，并且需要追加
    } else {
      state[key] = value // 默认是覆盖
    }
  }

  const getData = (key) => {
    return state[key]
  }

  const increment = () => {
    state.count++
    console.log("increment", state.count)
  }

  const decrement = () => {
    state.count--
  }

  // Getters
  const doubleCount = computed(() => state.count * 2)

  return {
    ...toRefs(state), // 展开所有状态
    setData,
    getData,
    increment,
    decrement,
    doubleCount,
  }
})
